module.exports = __webpack_public_path__ + "img/beeline.3513a35a.png";